<template>
    <div class="cta-caja cta-caja--yellow" @click="clicking">
      <div class="cta-caja__cover">
        <img
          class="cta-caja__cover-desk"
          src="https://images.hellobb.net/extractor-desktop.jpg"
          alt=""
        />
        <img
          class="cta-caja__cover-mobile"
          src="https://images.hellobb.net/extractor-responsive.jpg"
          alt=""
        />
      </div>
      <div class="cta-caja__content">
        <h4 class="cta-caja__title">Extractor de leche eléctrico Philips Avent</h4>
        <div class="cta-caja__description">
          <p>Un modelo clásico de una gran marca.</p>
        </div>
        <div class="cta-caja__actions">
          <loading-button v-if="loading" :class="'button-loading--sm'" />
          <button
            class="button button--accent button--sm button--ico"
            @click.stop="addProduct('Constructor - Banner Horitzontal')"
            :disabled="added"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
      <modal-dialog
          :show="showProductAddedDialog"
          @close="showProductAddedDialog = false"
          target-class="modal__card--mini"
      >
        <product-added-to-list/>
      </modal-dialog>
    </div>
  </template>
  
  <script>
  import Product from "./Mixins/Product";
  import LoadingButton from "../../../components/LoadingButton";
  import ModalDialog from "../../../components/ui/ModalDialog";
  import ProductAddedToList from "../../../components/ProductAddedToList";
  
  export default {
    name: "CtaExtractorPhilipsAvent",
    mixins: [Product],
    components: {
      LoadingButton,
      ModalDialog,
      ProductAddedToList
    },
    computed: {
      buttonText() {
        return this.added ? "Añadido" : "Añadir a mi lista";
      },
    },
    created() {
      this.product = {
        id: 38921,
        "brand-slug": "philips-avent",
        name: "Extractor de leche eléctrico Philips Avent",
        retailerName: "HelloBB",
        productRetailers: [{"name": "HelloBB"}]
      };
    },
    methods: {
      clicking()
      {
        mixpanel.track("Click element constructor", {
          "Name": "Extractor de leche eléctrico Philips Avent",
          "Section": "Objetos de calidad que seguro te duran para el siguiente bebé",
          "Section number": 5,
          "Type": "Banner - Horizontal",
          "Content": "Ecommerce"
        });
        this.browseProduct();
      }
    }
  };
  </script>